import $ from 'jquery';
import { triggerStateChangedRequest } from '~core';
import {
  setSvgColor,
  updateTextColorControl,
  updateFontSizeInput,
  updateTextAlignControl,
  updateTextSpacingControls,
  getFontSizeValue,
  updateTextOpacityControl,
} from '~src/ui';
import {
  updateTextBorderColorControl,
  updateTextBorderThicknessControl,
} from '~core/borders';
import { hideAllMenus } from '~core/hideAllMenus';
import { toggleEditorSidebar } from '../sidebarLegacy';
import { editorConfig } from '~config';
import { getState } from '~src/state';
import axios from 'axios';
import { clearSelectionsStyles } from '~src/utils';

export function titleCase(str = '') {
  var splitStr = str.toLowerCase().split(' ');
  for (var i = 0; i < splitStr.length; i++) {
    // You do not need to check if i is larger than splitStr length, as your for does that for you
    // Assign it back to the array
    splitStr[i] =
      splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
  }
  // Directly return the joined string
  return splitStr.join(' ');
}

function changeFontFamily(fontFamily) {
  const activeObject = getState('activeObject');

  if (activeObject.isEditing) {
    const { selectionStart, selectionEnd } = activeObject;

    if (
      activeObject.text &&
      selectionStart === 0 &&
      selectionEnd === activeObject.text.length
    ) {
      // everything was selected
      clearSelectionsStyles(activeObject, 'fontFamily');
      activeObject.fontFamily = fontFamily;
    } else if (selectionStart === selectionEnd) {
      // no text was selected
      activeObject.fontFamily = fontFamily;
    } else {
      // a portion of text was selected
      activeObject.setSelectionStyles({ fontFamily });
    }
  } else {
    clearSelectionsStyles(activeObject, 'fontFamily');
    activeObject.fontFamily = fontFamily;
  }
  $('#control-fontfamily-name').text(fontFamily);
  window.canvas.renderAll();
  triggerStateChangedRequest();
}

// TODO: [DEV-344] review why activeObject is not used
// function changeTextAlign(textAlign) {
//   const activeObject = getState('activeObject');

//   if (activeObject.isEditing) {
//     activeObject.setSelectionStyles({ textAlign });
//   } else {
//     activeObject.textAlign = textAlign;
//   }

//   window.canvas.renderAll();
//   toggleTextAlignPopper();
// }

function onFontFamilyChange(e) {
  e.preventDefault();
  const fontFamily = $(this).data('font-family');
  return changeFontFamily(fontFamily);
}

const beautifyFontName = (rawFontName) => {
  return titleCase(rawFontName.replace(/-/g, ' '));
};

const loadFonts = async () => {
  const {
    data: { websafe, google, custom, adobe, adobeProjectId },
  } = await axios.get(`${process.env.OFC_CDN_URL}/fonts/index.json`);

  const orderedFontFamilies = [
    ...websafe,
    ...google,
    ...custom,
    ...adobe,
  ].sort();
  const fontItems = orderedFontFamilies.reduce((acc, fontName) => {
    const item = `<div data-font-family="${fontName}" data-search-font-family="${fontName.toLowerCase()}" class="font-item" style="font-family:${fontName}">${beautifyFontName(
      fontName
    )}</div>`;
    acc += item;
    return acc;
  }, '');

  return new Promise((resolve) => {
    let completed = false;
    const completeFontLoading = () => {
      if (completed) return;
      completed = true;
      $('body').off('click', '[data-font-family]');
      $('body').on('click', '[data-font-family]', onFontFamilyChange);
      $('#popper-font-family-scroller').html(fontItems);
      resolve();
    };

    if (!window.WebFont || typeof window.WebFont.load !== 'function') {
      completeFontLoading();
      return;
    }

    try {
      window.WebFont.load({
        custom: {
          families: custom,
        },
        google: {
          families: google,
        },
        typekit: { id: adobeProjectId, api: '//use.typekit.net' },
        active: completeFontLoading,
        inactive: completeFontLoading,
      });
    } catch (error) {
      completeFontLoading();
    }
  });
};

function updateFontStyleControls() {
  let fontFamily;
  let fontWeight;
  let fontStyle;
  let fontUnderline;
  let fontShadow;

  const activeObject = getState('activeObject');

  if (activeObject.isEditing) {
    // the text object is being edited
    const { selectionStart, selectionEnd } = activeObject;

    if (selectionStart === selectionEnd) {
      // no text was selected
      fontFamily = activeObject.fontFamily;
      fontWeight = activeObject.fontWeight;
      fontStyle = activeObject.fontStyle;
      fontUnderline = activeObject.underline;
      fontShadow = activeObject.shadow;
    } else {
      const selectionStyles = activeObject.getSelectionStyles();
      if (selectionStyles && selectionStyles.length > 0 && selectionStyles[0]) {
        const activeSelection = selectionStyles[0];
        // a portion of text was selected
        fontFamily = activeSelection['fontFamily'];
        fontWeight = activeSelection['fontWeight'];
        fontStyle = activeSelection['fontStyle'];
        fontUnderline = activeSelection['underline'];
        fontShadow = activeSelection['shadow'];
      }
    }
  } else {
    // the text object is simply selected
    fontFamily = activeObject.get('fontFamily');
    fontWeight = activeObject.get('fontWeight');
    fontStyle = activeObject.get('fontStyle');
    fontUnderline = activeObject.get('underline');
    fontShadow = activeObject.get('shadow');
  }

  $('#control-fontfamily-name').text(fontFamily);

  const isStyleItalic = fontStyle === 'italic';
  if (isStyleItalic) {
    setSvgColor('#img-italic-text', editorConfig.styles.activeControlColor);
  } else {
    setSvgColor('#img-italic-text', editorConfig.styles.inactiveControlColor);
  }

  const isStyleBold = fontWeight === 'bold' || parseInt(fontWeight) >= 600;
  if (isStyleBold) {
    setSvgColor('#img-bold-text', editorConfig.styles.activeControlColor);
  } else {
    setSvgColor('#img-bold-text', editorConfig.styles.inactiveControlColor);
  }

  if (fontUnderline) {
    setSvgColor('#img-underline-text', editorConfig.styles.activeControlColor);
  } else {
    setSvgColor(
      '#img-underline-text',
      editorConfig.styles.inactiveControlColor
    );
  }

  if (fontShadow) {
    setSvgColor('#img-shadow-text', editorConfig.styles.activeControlColor);
  } else {
    setSvgColor('#img-shadow-text', editorConfig.styles.inactiveControlColor);
  }
}

function changeFontSize(fontSize) {
  if (fontSize > 1) {
    const activeObject = getState('activeObject');
    if (activeObject.isEditing) {
      const { selectionStart, selectionEnd } = activeObject;

      if (
        activeObject.text &&
        selectionStart === 0 &&
        selectionEnd === activeObject.text.length
      ) {
        // everything was selected
        clearSelectionsStyles(activeObject, 'fontSize');
        activeObject.fontSize = fontSize;
      } else if (selectionStart !== selectionEnd) {
        // a portion of text was selected
        activeObject.setSelectionStyles({ fontSize });
      }
    } else {
      clearSelectionsStyles(activeObject, 'fontSize');
      activeObject.set('fontSize', fontSize);
      activeObject.set('dirty', true);
    }
    window.canvas.renderAll();

    triggerStateChangedRequest();
    updateFontSizeInput();
  }
}

function fontSizePlus() {
  let fontSize = getFontSizeValue();
  let fontSizePlusValue = fontSize + 20;
  changeFontSize(fontSizePlusValue);
}

function fontSizeMinus() {
  let fontSize = getFontSizeValue();
  let fontSizePlusValue = fontSize - 20;
  // if (fontSize <= 40) {
  //   document.getElementById('editor-menu-font-size-minus').disabled = true;
  // } else {
  changeFontSize(fontSizePlusValue);
  // }
}

function showMenuText() {
  hideAllMenus();
  $('#editor-menu-text').show();
  $('#editor-menu-object').show();
}

function onObjectTextSelected() {
  const isSidebarOpen = getState('isSidebarOpen');

  showMenuText();
  updateFontStyleControls();
  updateTextColorControl();
  updateTextBorderColorControl();
  updateTextAlignControl();
  updateFontSizeInput();
  updateTextSpacingControls();
  updateTextOpacityControl();
  updateTextBorderThicknessControl();

  // Hide non-text sidebar
  if (isSidebarOpen && $('.tab.active').length) {
    const tabObjectType = $('.tab.active').first().data('object-type');
    if (tabObjectType !== 'text') {
      toggleEditorSidebar();
    }
  }
}

function hideMenuText() {
  $('#editor-menu-default').show();
  $('#editor-menu-text').hide();
  $('#editor-menu-object').hide();
}

// function hideMenuDefault() {
//   $('#editor-menu-default').hide();
// }

// function hideMenuCrop() {
//   $('#editor-menu-crop').hide();
// }

/**
 * Trigger: text selection has changed
 */
function onSelectTextEditing() {
  updateFontStyleControls();
  updateTextColorControl();
  updateTextBorderColorControl();
  updateTextAlignControl();
  updateTextBorderThicknessControl();
}

const isStyleBold = (fontWeight) =>
  fontWeight === 'bold' || parseInt(fontWeight) >= 600;

function toggleFontWeightBold() {
  const activeObject = getState('activeObject');

  if (activeObject.isEditing) {
    const selectionStyles = activeObject.getSelectionStyles();
    const fontWeight =
      selectionStyles && selectionStyles.length > 0 && selectionStyles[0]
        ? selectionStyles[0].fontWeight
        : activeObject.get('fontWeight');
    const { selectionStart, selectionEnd } = activeObject;

    if (
      activeObject.text &&
      selectionStart === 0 &&
      selectionEnd === activeObject.text.length
    ) {
      // everything was selected
      clearSelectionsStyles(activeObject, 'fontWeight');
      if (isStyleBold(activeObject.fontWeight)) {
        activeObject.fontWeight = 'normal';
      } else {
        activeObject.fontWeight = 'bold';
      }
    } else if (selectionStart !== selectionEnd) {
      // a portion of text was selected
      if (isStyleBold(fontWeight)) {
        activeObject.setSelectionStyles({
          fontWeight: 'normal',
        });
      } else {
        activeObject.setSelectionStyles({
          fontWeight: 'bold',
        });
      }
    }
  } else {
    clearSelectionsStyles(activeObject, 'fontWeight');
    if (isStyleBold(activeObject.fontWeight)) {
      activeObject.fontWeight = 'normal';
    } else {
      activeObject.fontWeight = 'bold';
    }
  }

  window.canvas.renderAll();

  triggerStateChangedRequest();
  updateFontStyleControls();
}

function toggleFontStlyeItalic() {
  const activeObject = getState('activeObject');

  if (activeObject.isEditing) {
    const styles = activeObject.getSelectionStyles();
    const { selectionStart, selectionEnd } = activeObject;

    if (
      activeObject.text &&
      selectionStart === 0 &&
      selectionEnd === activeObject.text.length
    ) {
      // everything was selected
      clearSelectionsStyles(activeObject, 'fontStyle');
      if (activeObject.fontStyle === 'normal') {
        activeObject.fontStyle = 'italic';
      } else {
        activeObject.fontStyle = 'normal';
      }
    } else if (selectionStart !== selectionEnd) {
      // a portion of text was selected
      if (styles && styles[0] && styles[0].fontStyle === 'italic') {
        activeObject.setSelectionStyles({
          fontStyle: 'normal',
        });
      } else {
        activeObject.setSelectionStyles({
          fontStyle: 'italic',
        });
      }
    }
  } else {
    clearSelectionsStyles(activeObject, 'fontStyle');
    if (activeObject.fontStyle === 'normal') {
      activeObject.fontStyle = 'italic';
    } else {
      activeObject.fontStyle = 'normal';
    }
  }

  window.canvas.renderAll();

  triggerStateChangedRequest();
  updateFontStyleControls();
}

function toggleTextUnderline() {
  const activeObject = getState('activeObject');

  if (activeObject.isEditing) {
    const styles = activeObject.getSelectionStyles();
    const { selectionStart, selectionEnd } = activeObject;

    if (
      activeObject.text &&
      selectionStart === 0 &&
      selectionEnd === activeObject.text.length
    ) {
      // everything was selected
      clearSelectionsStyles(activeObject, 'underline');
      if (activeObject.get('underline')) {
        activeObject.set('underline', false);
      } else {
        activeObject.set('underline', true);
      }
    } else if (selectionStart !== selectionEnd) {
      // a portion of text was selected
      if (styles && styles[0] && styles[0].underline) {
        activeObject.setSelectionStyles({
          underline: false,
        });
      } else {
        activeObject.setSelectionStyles({
          underline: true,
        });
      }
    }
  } else {
    clearSelectionsStyles(activeObject, 'underline');
    if (activeObject.get('underline')) {
      activeObject.set('underline', false);
    } else {
      activeObject.set('underline', true);
    }
    activeObject.set('dirty', true);
  }

  window.canvas.renderAll();

  triggerStateChangedRequest();
  updateFontStyleControls();
}

function editorSetTextAlign(textAlign = 'left') {
  const activeObject = getState('activeObject');

  activeObject.set('textAlign', textAlign);
  activeObject.set('dirty', true);
  updateTextAlignControl();
  window.canvas.renderAll();
  triggerStateChangedRequest();
}

function setEditorSetTextSpacingH(charSpacing, saveHistory = false) {
  const activeObject = getState('activeObject');
  activeObject.set('charSpacing', charSpacing);
  activeObject.set('dirty', true);
  window.canvas.renderAll();

  if (saveHistory) {
    triggerStateChangedRequest();
  }
}

function setEditorSetTextSpacingV(lineHeight, saveHistory = false) {
  const activeObject = getState('activeObject');
  activeObject.set('lineHeight', lineHeight);
  activeObject.set('dirty', true);
  window.canvas.renderAll();

  if (saveHistory) {
    triggerStateChangedRequest();
  }
}

function onTextSpacingValueChangeV(e) {
  let value = parseFloat($(this).val());

  // Enforce min/max limits
  const min = 0.5;
  const max = 5;
  if (value < min) value = min;
  if (value > max) value = max;
  if (isNaN(value)) value = min;

  const saveHistory = e.type === 'change';

  // Update both controls to the clamped value
  $('#editor-text-spacing-v-slider').val(value);
  $('#editor-text-spacing-v-value').val(Math.round(value * 100) / 100);

  setEditorSetTextSpacingV(value, saveHistory);
}

function onTextOpacityValueChange(e) {
  const value = $(this).val();
  const activeObject = getState('activeObject');
  const saveHistory = e.type === 'change';
  activeObject.set({ opacity: value });
  window.canvas.renderAll();

  if (saveHistory) {
    triggerStateChangedRequest();
  }
}

function onTextSpacingValueChangeH(e) {
  let value = parseFloat($(this).val());

  // Enforce min/max limits
  const min = -200;
  const max = 1000;
  if (value < min) value = min;
  if (value > max) value = max;
  if (isNaN(value)) value = min;

  const saveHistory = e.type === 'change';

  // Update both controls to the clamped value
  $('#editor-text-spacing-h-slider').val(value);
  $('#editor-text-spacing-h-value').val(Math.round(value * 100) / 100);

  setEditorSetTextSpacingH(value, saveHistory);
}

$('body').on('change', '#editor-font-size-input', function () {
  changeFontSize(this.value * 10);
});

export {
  loadFonts,
  toggleFontWeightBold,
  toggleFontStlyeItalic,
  editorSetTextAlign,
  toggleTextUnderline,
  onTextSpacingValueChangeV,
  onTextSpacingValueChangeH,
  onObjectTextSelected,
  hideMenuText,
  showMenuText,
  onSelectTextEditing,
  fontSizePlus,
  fontSizeMinus,
  onTextOpacityValueChange,
};
